import linkifyHtml from 'linkify-html';

import lineBreaker from '../../utils/lineBreaker';

const AddressWithLink = ({ address, lat, lng }) => {
  const isGoogleMapLink = lat && lng;
  const formattedAddress = (
    <span
      dangerouslySetInnerHTML={{
        __html: lineBreaker(linkifyHtml(address)),
      }}
    />
  );
  return isGoogleMapLink ? (
    <a
      target="_blank"
      rel="noreferrer noopener"
      className="outlet-address"
      href={`https://www.google.com/maps/place/${lat},${lng}`}
    >
      {formattedAddress}
    </a>
  ) : (
    formattedAddress
  );
};

export default AddressWithLink;
